import { api } from '../api';

export const zeroClaimReport = api.injectEndpoints({
    endpoints: (builder) => ({
        getZeroClaimReports: builder.query({
            query: (payload) => ({
                url: 'api/report/zero-claim-report/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'list'
                }
            })
        }),
        downloadZeroClaimsReports: builder.query({
            query: (payload) => ({
                url: 'api/report/zero-claim-report/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'list'
                },

                responseHandler: (res) =>
                    res.blob().then((blob) => ({
                        blob,
                        fileName: res.headers.get('content-disposition').split('filename=')[1],
                        type: res.headers.get('content-type')
                    }))
            })
        })
      
    })
});

export const {
    useLazyDownloadZeroClaimsReportsQuery,
    useLazyGetZeroClaimReportsQuery
} = zeroClaimReport;
